// const BASE_URL = process.env.BASE_URL || "https://peymash.ir/api";
const BASE_URL = process.env.REACT_APP_BASE_URL || "http://localhost:4000";

export default BASE_URL;
